<template>
  <div v-if="shouldRenderConfig && getShowCostCenter" :class="getClassName">
    <div class="matrix_costCenterLabel">
      {{ $t(name) }}
    </div>
    <input
      v-model="costCenter"
      type="text"
      :placeholder="$t('Enter number')"
      name="cost_center_number"
    />
  </div>
</template>
<script>
import { useCostCenterStore } from "@/stores/modules/costCenter";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useWebproductStore, ["getShowCostCenter"]),
    ...mapState(useCostCenterStore, ["getCostCenter"]),
    name: () => {
      return "Cost Center Number:";
    },
    costCenter: {
      get: function () {
        return this.getCostCenter;
      },
      set: function (newValue) {
        this.setCostCenter(newValue);
      }
    }
  },
  methods: { ...mapActions(useCostCenterStore, ["setCostCenter"]) }
};
</script>
